import React from 'react';
import { PropTypes } from 'prop-types';

import styles from './errorCircle/errorCircle.module.scss';

export const ErrorCircle = (props) => {
  const {
    className = '',
    size = 64,
    borderWidth = 4,
    lineWidth = 2,
  } = props;

  const containerStyle = {
    width: `${size / 16}rem`,
    height: `${size / 16}rem`,
    borderWidth: `${borderWidth / 16}rem`,
  };
  const rotatorStyle = {
    width: `${size * .5 / 16}rem`,
    height: `${size * .5 / 16}rem`,
  };

  return (
    <div className={`${styles.container} ${className}`} style={containerStyle}>
      <div className={styles.wrapper} style={rotatorStyle}>
        <div
          className={`${styles.line} ${styles.line1}`}
          style={{ height: `${lineWidth / 16}rem` }}
        />
        <div
          className={`${styles.line} ${styles.line2}`}
          style={{ width: `${lineWidth / 16}rem` }}
        />
      </div>
    </div>
  );
};

ErrorCircle.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number,
  borderWidth: PropTypes.number,
  lineWidth: PropTypes.number,
};
